export default function ProjectsFilters() {
  const filterButtons = document.querySelectorAll(".filter-btn");
  const projectsList = document.getElementById("projects-list");
  const ajaxUrl = "/wp-admin/admin-ajax.php";

  // Render projects template
  const renderProjects = (projects) => {
    if (!projects || projects.length === 0) {
      return '<div class="no-projects">No projects found.</div>';
    }

    let html = '<div class="row">';
    projects.forEach((project) => {
      console.log(project);

      html += `
        <div class="project-item">
            <div class="project-item__wrapper">
                <div class="project-item__image image--big">
                    <a href="${project.permalink}">
                        <div class="image-scale-animation">
                          <img class="project-item__image image--big" src="${project.image}">
                        </div>
                    </a>
                </div>
                <div class="project-item__content">
                    <div class="project-item__content__title">${project.title}</div>
                    <div class="project-item__content__type">
                        <div class="title">TYΠΟΣ</div>
                        <div class="type">${project.category}</div>
                    </div>
                    <a class="project-item__content__link f-button" href="${project.permalink}">ΔΕΙΤΕ ΤΟ PROJECT</a>
                </div>
                <div class="project-item__image image--small">
                    <a href="${project.permalink}">
                      <div class="image-scale-animation">
                        <img class="project-item__image image--small" src="${project.secondary_image}">
                      </div>
                    </a>
                </div>
            </div>
        </div>
      `;
      console.log(project.image);
    });
    html += "</div>";
    return html;
  };

  // Update projects display
  const updateProjectsDisplay = (data) => {
    if (data.success) {
      projectsList.innerHTML = renderProjects(data.data);
    } else {
      projectsList.innerHTML = '<div class="no-projects">No projects found.</div>';
    }
  };

  filterButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const isActive = this.classList.contains("active");

      // Remove active class from all buttons
      filterButtons.forEach((btn) => btn.classList.remove("active"));

      // If the clicked button was not active, add active class to it
      if (!isActive) {
        this.classList.add("active");
      }

      // Collect all active filter term IDs
      const activeBtns = document.querySelectorAll(".filter-btn.active");
      const activeTermIds = Array.from(activeBtns).map((btn) => btn.getAttribute("data-term-id"));

      // AJAX request to filter projects
      const formData = new FormData();
      formData.append("action", "filter_projects");
      formData.append("term_ids", activeTermIds.join(","));

      fetch(ajaxUrl, {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          updateProjectsDisplay(data);
        })
        .catch((error) => {
          console.error("AJAX Error:", error);
        });
    });
  });
}
